module.exports = __webpack_public_path__ + "static/img/1079_big.63587de.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1079_big.png
// module id = Fbvk
// module chunks = 1